
export const tour = [
	// quick start INDEX 1
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/quickstart-1.png',
			title: 'You are smart!',
			description: 'Get value from grafias today<br>This guide will show you the features<br>Turn it ON in profile settings, Show onboarding window',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/01.gif',
			title: 'Cloud-based production',
			description: 'Click the Quick Start Rundown button, this will import a sample rundown for you to explore<br><br>Learn about cloud-based graphics, click Next',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/quickstart-2.png',
			title: 'Rundown',
			description: 'Create graphics, timers, tickers, or add video and audio. Share it with your team and clients',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/02.gif',
			title: 'Plan your live production',
			description: 'Save time in preproduction<br>Edit the graphics in the Property Editor in real-time, together with your team and client',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/quickstart-3.png',
			title: 'Show the rundown to clients',
			description: 'Add the assets you need for the event. Click on the title to PREVIEW or PLAY to go LIVE<br>Collaborate with client so you have all the assets you need',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/quickstart-4.png',
			title: 'Work from anywhere',
			description: 'Add stunning graphics right in your browser, no expensive hardware required. Operate from any location',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/05.gif',
			title: 'One click to go live',
			description: 'Save time from pre-production to live production<br>LIVE window is what the your audience see<br>Make fast changes on the fly, and use Preview to check that all is ok',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/06.gif',
			title: 'Publish to your audience',
			description: 'Click View output, click Publish on Default display and click save. Create as many outputs you need and control it from same rundown.',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/07.gif',
			title: 'Vision mixer or cloud-based',
			description: 'Whether it’s vision mixers or cloud-based, integrate your rundown with any production tool with support for web source. Output to NDI, SDI with fill & Key',
			index: 1,
		},
	],
	// Rundowns INDEX 2
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+%E2%80%93+1.png',
			title: 'Add Asset',
			description: 'Click the plus button or Click to Add asset, select the asset you want to add and click',
			index: 2,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+%E2%80%93+2.png',
			title: 'Edit Property',
			description: 'Change the asset property, Name, Heading text, Duration, Image attachment, color and position<br>Every asset has different set of property',
			index: 2,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+%E2%80%93+3.png',
			title: 'Layer Index',
			description: 'Each asset occupied a layer index, only one asset can be active at a time, separate your asset in several layer index if you want to show it all at once',
			index: 2,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+-+4.gif',
			title: 'Select Template',
			description: 'For Lower third asset, you can select the various template from our library, open the gallery window, select the tempate for preview, double click or click Use this Template button to select the template for the asset',
			index: 2,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+%E2%80%93+5.png',
			title: 'PREVIEW',
			description: 'Quick view when editing the property of your asset, or transform the asset by draggin the bounding box<br>click on the asset name on the rundown, a green marker will appear on the left side of the asset',
			index: 2,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+%E2%80%93+6.png',
			title: 'PLAY',
			description: 'PLAY window is similar to PROGRAM window, its the final output view for your rundown',
			index: 2,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+%E2%80%93+7.png',
			title: 'Arrange Asset',
			description: 'Drag and Drop your asset on the rundown to change its order, add marker asset to make separate section so its easier to mage during live production',
			index: 2,
		},
	],
	// Rundown Settings INDEX 3
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+1.png',
			title: 'Filter & Search',
			description: 'Quickly find your asset by filtering the asset type or search by name',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+2.png',
			title: 'STOP',
			description: 'Stop all graphics in LIVE and PREVIEW at once, right click on the stop button to select either PREVIEW or LIVE only',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+3.png',
			title: 'Clear Output',
			description: 'Similar to STOP this will force clear all the graphics on the output display',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+4.png',
			title: 'Rename Rundown',
			description: 'My Event Rundown is the default name for newly created rundown, choose this menu to rename your rundown or double click on the rundown title on top left',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+5.png',
			title: 'Clear Rundown',
			description: 'This action will reset or delete all asset on your rundown',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+6.png',
			title: 'Render Rundown',
			description: 'You can export all the lower third as PNG sequence or MP4, for your NLE editor or other usage<br>A link to download the files will be send via email',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+7.png',
			title: 'Export Import',
			description: 'Export or Import rundown in Microsoft Excel format, if you have a lot of asset data, editing the excel file will save you alot of time. Grafias can handle hundreds of lower third data, for example list of graduated students',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+8.png',
			title: 'Import Lower Third Data',
			description: 'You can also import a specified excel format, fill in the data, and import to Grafias, select the template for this data and it will generate all the assets',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+9.png',
			title: 'Rebuild Cache',
			description: 'To ensure smooth playback, Grafias cache all media file, rebuild cache will download and cache the latest file for your rundown',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+10.png',
			title: 'Canvas Background',
			description: 'Change the background of LIVE and PREVIEW pane, by default is black luma, this setting is different from the output display type',
			index: 3,
		},
	],
	// Output In-Depth INDEX 4
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+1.png',
			title: 'Output List',
			description: 'View the output list, you can assign multiple output to a rundown, an output ony can be assign to a single rundown<br>Create output or view the multiview, multiview button only visible if you have more than one output',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+2.png',
			title: 'Create Output',
			description: 'Add output, Set the name and size based on the preset',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+3.png',
			title: 'Output Layers',
			description: 'Select output layers from the rundown, type in index layer then press enter, you can include several index in the output, or set 0 to display all index',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+4.png',
			title: 'Output Delay',
			description: 'Output delay in milliseconds, adjust the delay so it can be sync perfectly to your other output or stream',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+5.png',
			title: 'Background',
			description: 'Select the output background, Straight alpha, Luma (black) or Chroma (green), for OBS, select straight alpha, for other mixer select Luma or Chroma',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+6.gif',
			title: 'Assign Output',
			description: 'On Active Rundown, click select output, then click Publish button to assign an ouput to your rundown, then click Save',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+7.png',
			title: 'Active Output',
			description: 'View all active output assigned for this rundown, Click to open it on a new browser tab',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+8.png',
			title: 'Multiview',
			description: 'View all output in one place',
			index: 4,
		},
	],
	// Collaboration INDEX 5
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Collaborator/1.png',
			title: 'Collaborator List',
			description: 'Overview of all the collaborator, their role and the rundown',
			index: 5,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Collaborator/2.png',
			title: 'Invite Add Collaborator',
			description: 'Fill in the fullname and email field',
			index: 5,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Collaborator/3.png',
			title: 'Select Role',
			description: 'For Creator it is allowed to add and edit the rundown, but its not allowed to set the output or control during live session<br>Operator is for technical operator at the event, that set the output and control the rundown playback',
			index: 5,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Collaborator/4.png',
			title: 'Rundowns',
			description: 'Select the rundown to collaborate with, you can work on multiple rundown withe one user, the rundown will appear on user dashboard',
			index: 5,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Collaborator/5.png',
			title: 'Create Collaborator',
			description: 'An email will be dispatched to user, with quick registration process, non grafias user will easily start to collaborate on selected rundown',
			index: 5,
		},
	],
	// Asset - Lower Third INDEX 6
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+1.png',
			title: 'Overview Lower Third',
			description: 'Ready to use and fully customized lower third graphics to improve your production',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+2.gif',
			title: 'Select Template - Template Library',
			description: 'Many selection graphics library and will continue to grow<br>Search, filter or create your own graphic using Adobe After Effects and Bodymovin plugin (Lottie)',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+3.png',
			title: 'Heading',
			description: 'Basic template has maximum four heading (H1-H4), each template has different heading, fill in to replace the default text',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+4.png',
			title: 'Duration',
			description: 'Set the duration for the lower third, this is a peak point from transition in before it goes to transition out',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+5.png',
			title: 'Colors',
			description: 'Each template has different number of heading and element, change the color and opacity from the color picker',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+6.png',
			title: 'Text Drop Shadow',
			description: 'Enable drop shadow on the heading element',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+7.png',
			title: 'Gradient Color',
			description: ' Element on the template will have a gradient style, Solid color is the default looks',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+8.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+9.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+10.png',
			title: 'Speed',
			description: 'Change the playback speed, higher number is the fastest playback speed',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+11.png',
			title: 'Scale',
			description: 'Scale the graphics with predefined size (within)',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/On+Complete.png',
			title: 'On Complete',
			description: 'Trigger another asset to play, when current asset finished playing, select another asset from the dropdown',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 6,
		},
	],
	// Asset - Media INDEX 7
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+1.png',
			title: 'Overview Media',
			description: 'Play still image or video file from your rundown',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+2.gif',
			title: 'Media File',
			description: 'Upload from your device or select media from our library<br>For video files, MP4 files with HD resolution and medium bitrate for web playback are recommended',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+3.png',
			title: 'Video Loop & Mute Audio',
			description: 'Loop the video playback and mute if the video has embedded audio',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+4.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+5.png',
			title: 'In and Out Point',
			description: 'Define media playback length, split the playback from one file into several asset , without the need to edit or cut the media into separate file',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+6.png',
			title: 'Opacity',
			description: 'Set the asset opacity',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+7.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+8.png',
			title: 'Border',
			description: 'Border on the edge of the media file, change the thickness and color, if you crop the media the border will follow the cropped area',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+9.png',
			title: 'Crop Media',
			description: 'Crop the media, adjust the cropped amount on each side in pixels',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/On+Complete.png',
			title: 'On Complete',
			description: 'Trigger another asset to play, when current asset finished playing, select another asset from the dropdown',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 7,
		},
	],
	// Asset - Lottie INDEX 8
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Lottie/Asset+-+Lottie+%E2%80%93+1.png',
			title: 'Overview Lottie',
			description: 'Play lottie animations<br>Upload your lottie (json) file, or select from pur library, if your lottie files as bitmap assets, zip it and upload it as well',
			index: 8,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Lottie/Asset+-+Lottie+%E2%80%93+2.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 8,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Lottie/Asset+-+Lottie+%E2%80%93+3.png',
			title: 'Loop',
			description: 'Loop the video playback and mute if the video has embedded audio',
			index: 8,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Lottie/Asset+-+Lottie+%E2%80%93+4.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 8,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 8,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/On+Complete.png',
			title: 'On Complete',
			description: 'Trigger another asset to play, when current asset finished playing, select another asset from the dropdown',
			index: 8,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 8,
		},
	],
	// Asset - Ticker INDEX 9
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+1.png',
			title: 'Overview Ticker',
			description: 'Scrolling text across your display',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+2.png',
			title: 'Title & Display Time',
			description: 'Ticker title will appear on the left side, will have darker background, it can also display current time if you enable display time option',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+3.png',
			title: 'Ticker Data',
			description: 'Type in your ticker text then press enter to create your text, click the cross icon to remove it from the data',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+4.png',
			title: 'Ticker Style',
			description: 'Change the font style, color and the background of your ticker',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+5.png',
			title: 'Gradient & Hard Gradient',
			description: 'Enable and change the gradient style',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+6.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+7.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 9,
		},
	],
	// Asset - Timer INDEX 10
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Timer/Asset+-+Timer++%E2%80%93+1.png',
			title: 'Overview Timer',
			description: 'Create a time based counter display, there are several type of timer to fit your production',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Timer/Asset+-+Timer++%E2%80%93+2.png',
			title: 'Message',
			description: 'Display a message for the timer, clear the input to remove the message',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Timer/Asset+-+Timer++%E2%80%93+3.png',
			title: 'Duration or Time',
			description: 'Target duration or time, depends on the timer type, both have specific needs, select between a fixed time or a duration length',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Timer/Asset+-+Timer++%E2%80%93+4.png',
			title: 'Timer Style',
			description: 'Change the font style, color and the background of your ticker',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Timer/Asset+-+Timer++%E2%80%93+5.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Timer/Asset+-+Timer++%E2%80%93+6.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/On+Complete.png',
			title: 'On Complete',
			description: 'Trigger another asset to play, when current asset finished playing, select another asset from the dropdown',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 10,
		},
	],
	// Asset - Audio INDEX 11
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+1.png',
			title: 'Overview Audio',
			description: 'Playback audio with lyrics on your production - supported type .wav, .mp3, .ogg',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+2.png',
			title: 'Upload Audio or Select From Gallery',
			description: 'Select audio file from your computer or select from our library',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+3.png',
			title: 'Upload Lyric',
			description: 'in XML or JSON format, see example on how to set the lyrics timing',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+4.png',
			title: 'In and Out Point',
			description: 'Define media playback length, split the playback from one file into several asset , without the need to edit or cut the media into separate file',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+5.png',
			title: 'Loop and Mute',
			description: 'Loop audio playback<br>Quickly turn the audio on and off with toggle',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+6.png',
			title: 'Lyric Style',
			description: 'Change the font style, color and the background of your lyrics',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+7.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+8.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/On+Complete.png',
			title: 'On Complete',
			description: 'Trigger another asset to play, when current asset finished playing, select another asset from the dropdown',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 11,
		},
	],
	// Asset - Marker INDEX 12
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Marker/Asset+-+Marker++%E2%80%93+1.png',
			title: 'Overview Marker',
			description: 'Organize your rundown with marker, separate rundown with marker',
			index: 12,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Marker/Asset+-+Marker++%E2%80%93+2.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 12,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Marker/Asset+-+Marker++%E2%80%93+3.png',
			title: 'Color Style',
			description: 'Change the font color and background for your marker',
			index: 12,
		},
	],
	// Asset - Video Input INDEX 13
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+1.png',
			title: 'Overview Video Input',
			description: 'Select the video device from the list, webcam, digital camera, NDI or other camera source will be listed here<br>Allow access to camera if the permission popup appear.',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+2.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+3.png',
			title: 'Audio Input',
			description: 'Select the audio input from the device list',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+4.png',
			title: 'Mute Audio',
			description: 'Mute the audio from the input device',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+5.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+6.png',
			title: 'Border',
			description: 'Border on the edge of the media file, change the thickness and color, if you crop the media the border will follow the cropped area',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+7.png',
			title: 'Crop Media',
			description: 'Crop the media, adjust the cropped amount on each side in pixels',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 13,
		},
	],
	// Asset - Browser Source INDEX 14
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/BrowserSource/Asset+-+BrowserSourrce++%E2%80%93+1.png',
			title: 'Overview Browser Source',
			description: 'Embed Youtube video or webpage for your production',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/BrowserSource/Asset+-+BrowserSourrce++%E2%80%93+2.png',
			title: 'URL',
			description: 'Fill in the url for the webpage',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/BrowserSource/Asset+-+BrowserSourrce++%E2%80%93+3.png',
			title: 'Label and Show Label',
			description: 'The name of the asset, proper naming practice recommended, enable this to show the label on the asset',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/BrowserSource/Asset+-+BrowserSourrce++%E2%80%93+4.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/BrowserSource/Asset+-+BrowserSourrce++%E2%80%93+5.png',
			title: 'Border',
			description: 'Border on the edge of the media file, change the thickness and color, if you crop the media the border will follow the cropped area',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/BrowserSource/Asset+-+BrowserSourrce++%E2%80%93+6.png',
			title: 'Crop Media',
			description: 'Crop the media, adjust the cropped amount on each side in pixels',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 14,
		},
	],
	// Asset - Custom Command INDEX 15
	[
		{
			preview: '/img/content-placeholder.gif',
			title: 'Overview Custom Command',
			description: 'Embed Youtube video or webpage for your production',
			index: 15,
		},
	],
	// Asset - Composition INDEX 16
	[
		{
			preview: '/img/content-placeholder.gif',
			title: 'Overview Composition',
			description: 'Embed Youtube video or webpage for your production',
			index: 16,
		},
	],
	// Asset - Parent INDEX 17
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/ParentController/Parent+Controller+Detail+-+1.png',
			title: 'Parent Controller Toggle',
			description: 'Enable current as parent controller, all child linked to current asset will follow its state<br>if disabled, linked asset (child) will be ignored',
			index: 17,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/ParentController/Parent+Controller+Detail+-+2.png',
			title: 'Select Parent Item',
			description: 'Select Parent Item',
			index: 17,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/ParentController/Parent+Controller+Detail+-+3.png',
			title: 'Delay',
			description: 'the child asset can be shown before or after the parent is triggered, the delay is in milliseconds',
			index: 17,
		},
	],
];

export const related = [
	// INDEX 1
	{
		topic: ['Rundown', 'Rundown Settings', 'Output in-Depth', 'Collaboration'],
	},
	// INDEX 2
	{
		topic: ['Rundown Settings', 'Output in-Depth', 'Asset Lower Third'],
	},
	// INDEX 3
	{
		topic: ['Rundown', 'Output in-Depth', 'Collaboration'],
	},
	// INDEX 4
	{
		topic: ['Rundown', 'Rundown Settings', 'Collaboration', 'Quickstart'],
	},
	// INDEX 5
	{
		topic: ['Rundown', 'Rundown Settings', 'Output in-Depth', 'Quickstart'],
	},
	// INDEX 6
	{
		topic: ['Rundown', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 7
	{
		topic: ['Rundown', 'Lower Third', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 8
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 9
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 10
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 11
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 12
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Video Input', 'Browser Source'],
	},
	// INDEX 13
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Browser Source'],
	},
	// INDEX 14
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input'],
	},
	// INDEX 15
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 16
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 17
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
];
